import React from "react";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useIssueView } from "#app/components/issue-view";
import type { Omittable } from "@salestrak/ui";

function WorkflowIndex() {
  const { workspace, workflowId } = Route.useParams();
  const { issue: issueParam } = Route.useSearch();
  const { openIssueById } = useIssueView();

  // Deep link: ?issue=<id> should open the issue view. Handle it here — before
  // the redirect to /board — so a downstream effect isn't relied upon. We open
  // the issue directly, then redirect to a clean URL.
  const issueFromQuery =
    issueParam ??
    (typeof window !== "undefined"
      ? new URLSearchParams(window.location.search).get("issue")
      : null);

  const deepLinkHandled = React.useRef<string | null>(null);
  React.useEffect(() => {
    if (!issueFromQuery) return;
    if (deepLinkHandled.current === issueFromQuery) return;
    deepLinkHandled.current = issueFromQuery;
    openIssueById(issueFromQuery);
  }, [issueFromQuery, openIssueById]);

  return (
    <Navigate
      to={`/${workspace}/workflow/${workflowId}/board` as unknown as "/"}
    />
  );
}

export const Route = createFileRoute("/(app)/$workspace/workflow/$workflowId/")({
  validateSearch: (
    search: Record<string, unknown>,
    // A search param is written back as an explicit `undefined` to clear it —
    // the router reads that as "absent from the URL" — so the member relaxes.
  ): Omittable<{ issue?: string }> => ({
    issue: typeof search.issue === "string" ? search.issue : undefined,
  }),
  component: WorkflowIndex,
});
